<template>
  <div class="roleSetting">
    <el-container>
      <el-header>
        <div class="handlePanel">
          <el-button
            type="primary"
            icon="el-icon-tickets"
            @click="assignBtnPressed()"
          >权限维护</el-button>
        </div>
      </el-header>
      <el-main ref="main">
        <el-table
          ref="dataTable"
          :data="roleList"
          highlight-current-row
          size="mini"
          fit="false"
          height="100%"
          @selection-change="handleSelectionChange"
          @row-click="rowClicked"
          border
        >
          <el-table-column type="selection" width="50"></el-table-column>
          <el-table-column prop="deptName" label="组织名称" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="deptCode" label="组织编号" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="userName" label="最后操作人" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="userAccnt" label="最后操作人账号" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="updatedTime" label="最后操作时间" :show-overflow-tooltip="true"></el-table-column>
        </el-table>
      </el-main>
      <el-footer>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="deptForm.page"
          :page-sizes="[10, 20, 30, 40,50]"
          :page-size="deptForm.rows"
          layout="total, prev, pager, next, sizes, jumper"
          :total="total"
        ></el-pagination>
      </el-footer>
    </el-container>
    <!-- 菜单授权弹窗 -->
    <GovMenuAssignDialog ref="GovMenuAssignDialog"></GovMenuAssignDialog>
  </div>
</template>

<script>
import {
  getOneLevelDeptService
} from "../../services/sysSettingService";

import { getUserOneLevelDeptService } from "../../services/commonService";
import GovMenuAssignDialog from "../../components/systemSetting/GovMenuAssignDialog";
// import RoleAccountAssignDialog from "../../components/systemSetting/RoleAccountAssignDialog";

export default {
  name: "roleSetting",
  components: {
    GovMenuAssignDialog
  },
  data() {
    return {
      total: 0, //角色总数
      roleList: [], //角色列表
      isAddDialogShow: false, //新增角色弹窗显示开关
      isAdd: true, //新增/修改角色标识
      govSelectedList: [], //选中的角色数组
      deptList: [], //可选组织列表
      selectedDeptCode: "", //授权菜单的roleCode
      deptForm: {
        page: 1,
        rows: 20
      },
      addForm: {
        roleName: "",
        remark: "",
        deptCode: ""
      },
      addRules: {
        roleName: [
          { required: true, message: "请输入角色名称" },
          { min: 1, max: 10, message: "输入内容长度必须介于1到10之间" }
        ],
        remark: [{ min: 1, max: 10, message: "输入内容长度必须介于1到10之间" }],
        deptCode: [{ required: true, message: "请选择组织" }]
      },
    };
  },
  props: {
    menuCode: {
      type: String
    }
  },
  created() {},
  methods: {
    //激活时调用
    onActive(menuCode) {
      this.deptForm.page = 1;
      this.deptForm.rows = 20;
      this.getOneLevelDeptService();
    },
    /* 分页查询所有一级组织列表 */
    getOneLevelDeptService() {
      getOneLevelDeptService(this.deptForm).then(
        res => {
          console.log(res);
          if (res.resultCode == 0) {
            this.total = res.data.total;
            this.roleList = res.data.list;
          }
        },
        err => {
          this.$message.error("网络请求失败");
        }
      );
    },
    /* 分页改变事件 */
    handleCurrentChange(page) {
      console.log(page);
      this.deptForm.page = page;
      this.getAllRoles();
    },
    /* 分页显示数量改变事件 */
    handleSizeChange(rows) {
      this.deptForm.rows = rows;
      this.deptForm.page = 1;
      this.getAllRoles();
    },
    /* 列代表多选回调 */
    handleSelectionChange(govList) {
      this.govSelectedList = govList;
    },
    assignBtnPressed() {
      if (this.govSelectedList.length != 1) {
        this.$alert("每次只能选择一条记录进行修改！", "提示");
      } else {
        this.selectedDeptCode = this.govSelectedList[0].deptCode;
        this.$refs.GovMenuAssignDialog.refreshMenu(this.selectedDeptCode);
      }
    },
    closeAddDialog(){
      this.$refs.addForm.resetFields();
      this.isAddDialogShow = false;
    },
    // 点击选中行
    rowClicked(row, event, column) {
      this.$refs.dataTable.toggleRowSelection(row);
    }
  }
};
</script>

<style scoped lang="scss">
@import "@/assets/css/commonLayout.scss";
.roleSetting {
  height: 100%;
  background-color: white;
  display: flex;
  flex-direction: column;
}
.screenPanel {
  text-align: left;
  min-height: 40px;
  padding: 16px 0 0 0;
}
.handlePanel {
  text-align: right;
  // padding: 0 20px;
}
.el-select {
  width: 100%;
}
.el-form-item__label {
  text-align: left;
}
.el-footer {
  text-align: right;
}
.addDialog /deep/.el-dialog {
  width: 30%;
}
/deep/.el-radio-button__inner {
  background: #d5e7ed;
  border: none;
  border-radius: 0;
  box-shadow: none;
  :hover {
    background: #069dbc;
    color: #fff;
  }
}
/deep/.el-radio-button__orig-radio:checked + .el-radio-button__inner {
  background: #fff;
  color: #069dbc;
  border: none;
  border-radius: 0;
  box-shadow: none;
  :hover {
    background: #069dbc;
    color: #fff;
  }
}
</style>
